<template>
  <div class="content home">
    <section class="page-header is-paddingless is-marginless">
      <div class="level page-actions is-mobile is-centered">
        <div class="level-left">
          <div class="level-item">
            <h1>Play Queue</h1>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item" v-if="queuedAudioFiles.length">
            <queue-clear-button></queue-clear-button>
          </div>
        </div>
      </div>
    </section>
    <section class="section is-paddingless">
      <div class="columns is-marginless">
        <!-- Empty on this page; kept on desktop to align with other pages' content column. -->
        <aside class="column is-2 hero is-hidden-mobile"></aside>
        <main class="column is-paddingless">
          <div class="container p-b-90">
            <h5 class="play-queue__section-label">Now Playing</h5>
            <div v-if="currentAudioFile" class="p-b-30">
              <h2 class="play-queue__title">
                <router-link
                  v-if="currentAudioFile.song"
                  :to="{ name: 'songs.show', params: { id: currentAudioFile.song.id } }"
                  >{{ currentAudioFile.song.title }}</router-link
                >
              </h2>
              <p class="play-queue__writers">
                <span v-if="currentVersionName" class="play-queue__version">{{
                  currentVersionName
                }}</span
                >{{ currentAudioFile.song | orBlank('songwriter_names') }}
              </p>
              <p
                class="play-queue__file-name"
                :title="currentAudioFile.file_name"
              >
                {{ currentAudioFile | orBlank('file_name') }}
              </p>
            </div>
            <div v-else class="p-b-30">
              <div v-if="queuedAudioFiles.length">
                <p>
                  You're not playing anything right now. Click the Play button
                  to play the next song in your queue.
                </p>
                <queue-play-button
                  :queuedAudioFileId="queuedAudioFiles[0].id"
                ></queue-play-button>
              </div>
            </div>
            <hr />
            <h5 class="play-queue__section-label">Up Next</h5>
            <p v-if="!queuedAudioFiles.length" class="play-queue__empty">
              Nothing is queued. Play a song or playlist to add songs here.
            </p>
            <table v-else class="table is-fullwidth play-queue__table">
              <thead class="is-size-7">
                <tr>
                  <th class="has-text-grey-light">Title</th>
                  <th class="has-text-grey-light">Songwriters</th>
                  <th class="has-text-grey-light is-hidden-mobile">Audio File</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="queuedAudioFile in queuedAudioFiles"
                  :key="queuedAudioFile.id"
                >
                  <td class="has-text-dark has-text-weight-bold play-queue__song">
                    <router-link
                      v-if="queuedAudioFile.audio_file.song"
                      :to="{
                        name: 'songs.show',
                        params: { id: queuedAudioFile.audio_file.song.id }
                      }"
                      >{{ queuedAudioFile.audio_file.song.title }}</router-link
                    >
                  </td>
                  <td class="play-queue__writers">
                    {{
                      queuedAudioFile.audio_file.song
                        | orBlank('songwriter_names')
                    }}
                  </td>
                  <td
                    class="play-queue__file-name is-hidden-mobile"
                    :title="queuedAudioFile.audio_file.file_name"
                  >
                    {{ queuedAudioFile.audio_file.file_name }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </main>
      </div>
    </section>
  </div>
  <!-- /home -->
</template>

<script>
import store from '@/store'

import { QUEUED_AUDIO_FILE_USER_ALL } from '@/store/actions'

export default {
  name: 'AudioPlayerQueue',

  props: {},

  data() {
    return {}
  },

  computed: {
    queuedAudioFiles() {
      return this.$store.getters.getQueuedAudioFiles
    },

    currentAudioFile() {
      const audioFile = this.$store.state.audioPlayer.audioFile
      if (audioFile && audioFile.id) {
        return audioFile
      }
      return null
    },

    currentVersionName() {
      const type = this.currentAudioFile && this.currentAudioFile.type
      return type ? type.name : null
    }
  },

  beforeRouteEnter: function (to, from, next) {
    store.dispatch(QUEUED_AUDIO_FILE_USER_ALL)
    next()
  },

  beforeRouteUpdate: function (to, from, next) {
    store.dispatch(QUEUED_AUDIO_FILE_USER_ALL)
    next()
  },

  beforeCreate: function () {
    document.body.className = 'single'
  },

  methods: {}
}
</script>
